import { Toast } from '@/shared/ui';
import Modal from '@ebay/nice-modal-react';
import type { FC, PropsWithChildren } from 'react';

export const OverlaysProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <Toast />
      <Modal.Provider>{children}</Modal.Provider>
    </>
  );
};
